// extracted by mini-css-extract-plugin
export default {"title":"Other_title__IUS0B"};